import React from 'react';
import { useIntl } from 'react-intl';

import FilterChip from '~/components/Shared/Filters/FilterChip/FilterChip';
import { Chip } from '~/eds/src/components/Chip/Chip';
import { Filter } from '~/evifields/src/types/Filter';
import { useDrag } from '~/features/drag-and-drop/DragContext';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { SearchFilter } from '~/types/DashboardV2';

type Props = {
  index: number;
  filter: Filter;
  searchFilter?: SearchFilter;
  sectionIndex: number;
  onChange: (filter: Filter) => void;
  onRemove: () => void;
};

export const SectionItem = ({
  index,
  filter,
  searchFilter,
  sectionIndex,
  onChange,
  onRemove,
}: Props) => {
  const enableFilterViews = useFlag(FlagType.TextDelimitedMultiselectFilter);
  const { handleDragStart, handleDragEnd } = useDrag();
  const intl = useIntl();
  return searchFilter ? (
    <div
      draggable
      onDragStart={() =>
        handleDragStart({
          id: searchFilter.id,
          payload: { sectionIndex, index, filter },
        })
      }
      onDragEnd={handleDragEnd}
    >
      <FilterChip
        enableFilterViews={enableFilterViews}
        disableRemove={false}
        searchFilter={searchFilter}
        filter={filter}
        onChange={onChange}
        onRemove={onRemove}
      />
    </div>
  ) : (
    <Chip
      text={intl.formatMessage({
        id: 'SectionItem.removedFilter',
        defaultMessage: 'Remove Filter',
        description: 'Text for removed filter in query builder',
      })}
      status="danger"
      onRemove={onRemove}
      tooltip={intl.formatMessage({
        id: 'SectionItem.removedFilterTooltip',
        defaultMessage:
          'This field has been deleted. Remove the filter and save.',
        description: 'Tooltip for removed filter in query builder',
      })}
    />
  );
};
